module.exports = __webpack_public_path__ + "media/bom/Data-Sheet-Icon-On-a31a809e.svg";